/* eslint-disable */

import Chart from 'chart.js';

class BackendGraphs {
    constructor() {
        var element = document.getElementById('report-chart');
        if (element) {
            var data = JSON.parse(element.getAttribute('data-sets'));
            var labels = [];
            var impressions = [];
            var clicks = [];
            var clickRate = [];
            Object.keys(data).forEach(function (key) {
                var item = data[key];

                labels.push(item.date.substr(5, 5));
                impressions.push(item.impressions);
                clicks.push(item.clicks);
                clickRate.push(item.clickRate);
            });

            var ctx = element.getContext('2d');
            var myChart = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: labels,
                    datasets: [
                        {
                            label: 'Impressions',
                            data: impressions,
                            yAxisID:'impressions',
                        },
                        {
                            label: 'Klickrate',
                            data: clickRate,
                            yAxisID:'clicks',
                            type: 'line',
                            backgroundColor:'#000',
                            borderColor:'#000',
                            fill:false,
                            steppedLine:'middle',
                        },
                        {
                            label: 'Klicks',
                            data: clicks,
                            yAxisID:'clicks',
                            type: 'line',
                            backgroundColor:'#f00',
                            borderColor:'#f00',
                            fill:false
                        }
                    ]
                },
                options: {
                    scales: {
                        yAxes: [
                            {
                                position:'left',
                                id:'impressions',
                                ticks: {
                                    beginAtZero: true
                                }
                            },
                            {
                                position:'right',
                                id:'clicks',
                                ticks: {
                                    beginAtZero: true
                                }
                            }
                        ]
                    }
                }
            });
        }
    }
}

const backendGraphs = {
    init() {
        new BackendGraphs();
    },
};

export default backendGraphs;
